<template>
    <div class="content content-fixed content-auth">
        <div class="container">
            <div class="media align-items-stretch justify-content-center ht-100p">
                <div class="sign-wrapper mg-lg-r-50 mg-xl-r-60">
                    <div class="pd-t-20 wd-100p">
                        <h4 class="tx-color-01 mg-b-5">Create New Account</h4>
                        <p class="tx-color-03 tx-16 mg-b-40">It's free to signup and only takes a minute.</p>

                        <register-form></register-form>

                        <div class="divider-text">or</div>

                        <div class="tx-13 mg-t-20 tx-center">Already have an account? <router-link to="/logon">Sign In</router-link></div>
                    </div>
                </div><!-- sign-wrapper -->
                <div class="media-body pd-y-30 pd-lg-x-50 pd-xl-x-60 align-items-center d-none d-lg-flex pos-relative">
                    <div class="mx-lg-wd-500 mx-xl-wd-550">
                        <img src="../../assets/img/1.png" class="img-fluid" alt="">
                    </div>

                </div><!-- media-body -->
            </div><!-- media -->
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import RegisterForm from "../../components/form/RegisterForm";
    export default {
        name: "Register",
        components:{
            RegisterForm
        }
    }
</script>

<style scoped>

</style>